import React, { useState } from 'react';
import { DndContext, DragEndEvent } from '@dnd-kit/core';
import { MAX_WIDTH, MIN_WIDTH, modifiers } from './DraggableWrapper.meta';
import { Draggable } from './components/Draggable/Draggable';

export const DraggableWrapper = ({ children }) => {
  const [expanded, setExpanded] = useState(MIN_WIDTH);

  const handleDragEnd = ({ delta }: DragEndEvent) => {
    const deltaX = expanded + delta.x;

    if (deltaX >= MAX_WIDTH) {
      setExpanded(MAX_WIDTH);
      return;
    }

    if (deltaX <= MIN_WIDTH) {
      setExpanded(MIN_WIDTH);
      return;
    }

    setExpanded(state => state + delta.x);
  };

  return (
    <DndContext autoScroll={false} modifiers={modifiers} onDragEnd={handleDragEnd}>
      <Draggable expanded={expanded}>{children}</Draggable>
    </DndContext>
  );
};
